























































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import RoleRequest from "@/models/security/roleRequest.model";
import { RowTable } from "@/typings/BRowTable";
import AprobationStatus from "@/models/porposal/aprobationStatus.model";
import User from "@/models/security/user.model";
import UserService from "@/services/user.service";
import BaseVue from "../../core/BaseVue";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/annoucement/annoucement.Model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Porposal from "../../models/porposal/porposal.model";
import { ProposalState } from "@/enums/ProposalState";
import PorposalService from "@/services/porposal.service";
import { EvaluationState } from "@/enums/EvaluationState";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import fileService from "@/services/file.service";
import { PermissionValue } from '@/enums/PermissionValue';

@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    documentcomponent: DocumentComponent
  }
})
export default class ProposalsPrioritization extends GenericBTable<Porposal> {
  @Prop() public estado!: EvaluationState;
  proposalService: PorposalService = new PorposalService();
  showChangeStatus = false;
  annoucementId = null;
  codes = "";
  code = "";
  currentProposal = new Porposal();
  file = null;
  model = new AprobationStatus();
  loading = false;

  created() {
    this.permissionValue = PermissionValue.PRIORIZACIONPROPUESTA;
    this.tableConfig.controller = `Porposal/GetByEvaluationState/${this.estado}`;
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.proposal", true);
    name.customTemplate = true;

    let researchCenter = new BTableColumn(
      "researchCenter",
      "table.researchCenter",
      true
    );
    researchCenter.customTemplate = true;

    this.tableConfig.insertColumns(name, researchCenter);

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }
  public verOpciones(row: Porposal) {
    this.$router.push(`/convocatoria/propuesta/evaluaciones/${row.id}/detail`);
  }

  public changeStatus(row: Porposal) {
    this.showChangeStatus = true;
    this.currentProposal = row;
  }
  public cancelChangeStatus() {
    this.showChangeStatus = false;
  }
  public onModalClose() {
    this.model.init();
    this.file = null;
  }
  @Watch("annoucementId")
  getByAnnoucement() {
    this.tableConfig.whereParams = ` annoucementId eq  ${this.annoucementId}`;
    this.tableConfig.reload();
  }
  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = ` contains(Code, '${this.code}')`;
    this.tableConfig.reload();
  }
  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }

  async save() {
    if (!this.file) {
      this.operationFailed(
        "Favor subir un archivo de constancia de este cambio!",
        5000
      );
    } else {
      this.$buefy.dialog.confirm({
        title: "Advertencia",
        type: "is-warning",
        size: "is-medium",
        hasIcon: true,
        confirmText: "Sí",
        cancelText: "No",
        message: this.model.isApprove
          ? "¿Seguro que desea convertir este propuesta a proyecto?, de ser asi esta propuesta aparecerá en proyectos sin ejecutar."
          : "¿Seguro que desea rechazar este propuesta?, de ser asi esta propuesta aparecerá en propuestas rechazadas.",
        onConfirm: () => this.onConfirmSave()
      });
    }
  }

  async onConfirmSave() {
    this.loading = true;
    let doc = await fileService.upload(this.file as File);

    doc.refEntityKey = "Id";
    doc.refEntityName = "Proposal";
    doc.refEntityValue = this.currentProposal.id as any;

    this.model.document = doc;

    this.proposalService
      .changeAprobationStatus(this.currentProposal.id, this.model)
      .then(() => {
        this.cancelChangeStatus();
        this.operationSuccess();
        this.tableConfig.reload();
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
